import store from "../store/index";
import ApiHelpers from "../helpers/ApiHelpers";
import { ANNOUNCEMENT_ENDPOINT } from "../constants/urls";

export const announcementsService = {
  fetchAnnouncements,
  fetchAnnouncementCount,
  fetchAnnouncementById,
  createAnnouncement,
  bulkCreateAnnouncements,
  updateAnnouncement,
  deleteAnnouncement,
  markAllAnnouncementsAsRead,
  logAnnouncementView,
};

function buildScopeParams({ entityType = null, entityId = null } = {}) {
  const params = new URLSearchParams();
  if (entityType) params.append("entityType", entityType);
  if (entityId) params.append("entityId", entityId);
  return params;
}

async function fetchAnnouncements({ entityType = null, entityId = null, nextPageToken = null, searchQuery = null, startDate = null, endDate = null, isNewestFirst = true, onlyUnread = false, onlyGlobal = false, pageSize = 25 } = {}) {
  const params = buildScopeParams({ entityType, entityId });
  if (nextPageToken) params.append("nextPageToken", nextPageToken);
  if (searchQuery) params.append("searchQuery", searchQuery);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  params.append("isNewestFirst", isNewestFirst);
  params.append("onlyUnread", onlyUnread);
  params.append("onlyGlobal", onlyGlobal);
  params.append("pageSize", pageSize);

  const url = `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}?${params.toString()}`;
  const response = await ApiHelpers.makeAPICall(url, "GET", null, false);
  const text = await response.text();
  const body = text ? JSON.parse(text) : null;

  if (body?.status?.toLowerCase() === "success") {
    return { payload: body.payload || [], nextPageToken: body.nextPageToken || null };
  }
  return Promise.reject(body?.error || { message: "Some error occured." });
}

async function fetchAnnouncementCount({ entityType = null, entityId = null, onlyGlobal = false, searchQuery = null } = {}) {
  const params = buildScopeParams({ entityType, entityId });
  if (onlyGlobal) params.append("onlyGlobal", onlyGlobal);
  if (searchQuery) params.append("searchQuery", searchQuery);
  const url = `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/count?${params.toString()}`;
  const response = await ApiHelpers.makeAPICall(url, "GET", null, false);
  return await handleResponse(response);
}

async function fetchAnnouncementById(id) {
  const url = `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/${id}`;
  const response = await ApiHelpers.makeAPICall(url, "GET", null, false);
  return await handleResponse(response);
}

async function createAnnouncement(announcementData) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}`,
    "POST",
    JSON.stringify(announcementData),
    true
  );
  return await handleResponse(response);
}

async function bulkCreateAnnouncements(announcementData) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/bulk`,
    "POST",
    JSON.stringify(announcementData),
    true
  );
  return await handleResponse(response);
}

async function updateAnnouncement(announcementId, announcementData) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/${announcementId}`,
    "PUT",
    JSON.stringify(announcementData),
    true
  );
  return await handleResponse(response);
}

async function deleteAnnouncement(announcementId) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/${announcementId}`,
    "DELETE",
    null,
    false
  );
  return response.ok;
}

async function markAllAnnouncementsAsRead({ entityType = null, entityId = null, onlyGlobal = false, searchQuery = null } = {}) {
  const params = buildScopeParams({ entityType, entityId });
  if (onlyGlobal) params.append("onlyGlobal", onlyGlobal);
  if (searchQuery) params.append("searchQuery", searchQuery);
  const url = `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/read-all?${params.toString()}`;
  const response = await ApiHelpers.makeAPICall(url, "POST", null, false);
  return await handleResponse(response);
}

async function logAnnouncementView(ids) {
  const response = await ApiHelpers.makeAPICall(
    `${store.state.appState.apiURL}${ANNOUNCEMENT_ENDPOINT}/view`,
    "POST",
    JSON.stringify(ids),
    false
  );
  return await handleResponse(response);
}

async function handleResponse(response) {
  try {
    const text = await response.text();
    const body = text ? JSON.parse(text) : null;

    if (body?.status?.toLowerCase() === "success") {
      return body.payload;
    }
    return Promise.reject(body?.error || { message: "Some error occured." });
  } catch (error) {
    return Promise.reject({ message: "Some error occured." });
  }
}
